function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useMemo, useState } from 'react';
import computeScrollIntoView from 'compute-scroll-into-view';
import styled, { css } from 'styled-components';
import { Card } from '../../cards/card';
import { z30 } from '../../theme/z-index';
import { size2, size4, size8, size14, CONTROL_SIZE_MAP } from '../../theme/scale';
import * as COLORS from '../../theme/colors';
import { gray100, gray300, gray600, gray800, primary600 } from '../../theme/colors';
import { fontRegular, fontBold, fontBuenosAiresBold } from '../../theme/fonts';
import ItemList from './item-list';
const DropdownCard = styled(props => /*#__PURE__*/React.createElement(Card, props))`
  border-radius: 0 0 ${size4} ${size4};
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  z-index: ${z30};
`;
const YPaddings = {
  sm: '6px',
  md: '9px',
  lg: '14px'
};
const DropownMenu = styled.ul`
  ${({
  maxHeight
}) => maxHeight && `max-height: ${maxHeight}px;`}
  font-family: ${fontRegular};
  list-style: none;
  margin: 0;
  ${({
  joyableTheme
}) => joyableTheme && `padding: inherit;`}
  overflow-y: scroll;
`;
export const DropdownItem = styled.li`
  align-items: center;
  color: ${gray800};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-family: ${fontRegular};
  ${({
  hovered
}) => hovered && `background: ${gray100};`}
  ${({
  size
}) => size && `
    padding: ${CONTROL_SIZE_MAP[size].padding};
    font-size: ${CONTROL_SIZE_MAP[size]['font-size']};
    padding-top: ${YPaddings[size]};
    padding-bottom: ${YPaddings[size]};
  `}

  ${({
  selected,
  joyableTheme
}) => selected && css`
      color: ${joyableTheme ? COLORS.black : primary600};
      font-family: ${joyableTheme ? fontBuenosAiresBold : fontBold};
      position: relative;

      &::before {
        content: '';
        position: absolute;
        height: 100%;
        width: ${size2};
        background: ${joyableTheme ? COLORS.black : primary600};
        left: 0;
        top: 0;
        bottom: 0;
      }
    `}

  &:hover {
    cursor: pointer;
  }
`;
const DropdownItemGroup = styled.div`
  &:not(:last-of-type) {
    border-bottom: 1px solid ${gray300};
  }
`;
export const highlightMenuItem = (item, inputValue) => {
  const label = item.toLowerCase();
  const input = inputValue.toLowerCase();
  const index = label.indexOf(input);
  const inputLength = input.length;
  return `${item.substr(0, index)}<b>${item.substr(index, inputLength)}</b>${item.substr(index + inputLength)}`;
};
const GroupedHeaderTitle = styled.div`
  color: ${gray600};
  font-size: ${size14};
  padding: ${size8};
`;
const GroupHeader = ({
  title
}) => /*#__PURE__*/React.createElement(GroupedHeaderTitle, null, title);

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-constraint
export const Menu = ({
  items,
  menuProps = {},
  maxHeight = 0,
  size = 'md',
  inputValue,
  searchable,
  showContext,
  joyableTheme
}) => {
  const [scrollToSelected, setScrollToSelected] = useState(false);
  useEffect(() => {
    if (scrollToSelected) return;
    const selectedId = items.find(item => item.props.selected);
    if (!selectedId) return;
    const node = document.getElementById(selectedId.props.id);
    if (!node) return;
    computeScrollIntoView(node, {
      scrollMode: 'if-needed',
      block: 'center',
      inline: 'center',
      boundary: parent => {
        if (parent.nodeName === 'BODY') return false;
        return true;
      }
    }).forEach(({
      el,
      top,
      left
    }) => {
      el.scrollTop = top;
      el.scrollLeft = left;
    });
    setScrollToSelected(true);
  }, [items, scrollToSelected]);
  const groupedItems = useMemo(() => {
    return items.reduce((carry, item) => {
      if (!item.group) {
        return {
          ...carry,
          other: [...carry.other, item]
        };
      }
      return {
        ...carry,
        groups: {
          ...carry.groups,
          [item.group]: carry.groups[item.group] ? [...carry.groups[item.group], item] : [item]
        }
      };
    }, {
      groups: {},
      other: []
    });
  }, [items]);
  const itemGroups = Object.keys(groupedItems.groups);
  return /*#__PURE__*/React.createElement(DropdownCard, {
    padding: "0",
    elevation: "5"
  }, /*#__PURE__*/React.createElement(DropownMenu, _extends({}, menuProps, {
    maxHeight: maxHeight,
    joyableTheme: joyableTheme
  }), itemGroups.map(key => /*#__PURE__*/React.createElement(DropdownItemGroup, {
    key: key
  }, /*#__PURE__*/React.createElement(GroupHeader, {
    title: key
  }), /*#__PURE__*/React.createElement(ItemList, {
    items: groupedItems.groups[key],
    size: size,
    searchable: searchable,
    inputValue: inputValue,
    showContext: showContext,
    joyableTheme: joyableTheme
  }))), /*#__PURE__*/React.createElement(DropdownItemGroup, null, groupedItems.other.length > 0 && itemGroups.length > 0 && /*#__PURE__*/React.createElement(GroupHeader, {
    title: "Other"
  }), /*#__PURE__*/React.createElement(ItemList, {
    items: groupedItems.other,
    size: size,
    searchable: searchable,
    inputValue: inputValue,
    showContext: showContext,
    joyableTheme: joyableTheme
  })), items.length === 0 && /*#__PURE__*/React.createElement(DropdownItem, {
    size: size
  }, "No items available")));
};
export default Menu;
//# sourceMappingURL=menu.js.map